import React from 'react';
import MonthYearPicker from '../../../../components/inputs/MonthYearPicker';
import { momentParseDate } from '../../../../helpers';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';
import { MonthlyClosureDetailFilters } from '../../../../app/models/MonthlyClosureDetail';

type Props = {
    filter: MonthlyClosureDetailFilters;
    setFilter: (filter: MonthlyClosureDetailFilters) => void;
    onSearch: () => void;
};

const MonthlyClosureDetailWorkerFilter = ({ filter, setFilter, onSearch }: Props) => {
    
    const handlerInputFilter = (e: { target: { name: string; value: string } }) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    const handlerSelectFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="row">
                 <div className="col-auto mb-3">
                    <label className="font-size-10 mb-1" htmlFor="society">
                        Conductor
                    </label>
                    <input
                        title="Conductor"
                        type="text"
                        id="worker"
                        name="worker"
                        className="form-control form-control-sm"
                        value={filter.worker ?? ''}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
                <div className="col-auto">
                    <div className="mb-3">
                        <label className="font-size-10 mb-1" htmlFor="status">
                            Estado
                        </label>
                        <select
                            name="status"
                            className="form-control form-select-sm"
                            value={filter.status || ''}
                            onChange={(e) => handlerSelectFilter(e)}
                        >
                            <option value="">TODOS</option>
                            <option value="ABIERTO">Abierto</option>
                            <option value="CERRADO">Cerrado</option>
                            <option value="ANULADO">Anulado</option>
                        </select>
                    </div>
                </div>
                
                
                <div className='col-md-auto'>
                    <div style={{marginTop: '22px'}}>
                        <ButtonSearchFilter callbackSearch={onSearch}/>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default MonthlyClosureDetailWorkerFilter;
